// Network helpers are shared with SDK hosts that do not run the public web app.
// The public app still validates its complete environment at its root;
// getNetworkConfig independently rejects incomplete network configuration.
type NetworkEnvKey =
  | `NEXT_PUBLIC_${'API_URL' | 'NATS_URL' | 'RPC_URL' | 'PROGRAM_ID' | 'CP_SWAP_PROGRAM_ID' | 'MARKETS_PROGRAM_ID' | 'QUOTE_MINT' | 'SELL_CAP_PROGRAM'}_${'LOCAL' | 'DEVNET' | 'MAINNET'}`
  | 'NEXT_PUBLIC_DEV_PROXY';
export const networkEnv: Record<NetworkEnvKey, string | undefined> = {
  NEXT_PUBLIC_API_URL_LOCAL: process.env.NEXT_PUBLIC_API_URL_LOCAL,
  NEXT_PUBLIC_NATS_URL_LOCAL: process.env.NEXT_PUBLIC_NATS_URL_LOCAL,
  NEXT_PUBLIC_RPC_URL_LOCAL: process.env.NEXT_PUBLIC_RPC_URL_LOCAL,
  NEXT_PUBLIC_PROGRAM_ID_LOCAL: process.env.NEXT_PUBLIC_PROGRAM_ID_LOCAL,
  NEXT_PUBLIC_CP_SWAP_PROGRAM_ID_LOCAL: process.env.NEXT_PUBLIC_CP_SWAP_PROGRAM_ID_LOCAL,
  NEXT_PUBLIC_MARKETS_PROGRAM_ID_LOCAL: process.env.NEXT_PUBLIC_MARKETS_PROGRAM_ID_LOCAL,
  NEXT_PUBLIC_QUOTE_MINT_LOCAL: process.env.NEXT_PUBLIC_QUOTE_MINT_LOCAL,
  NEXT_PUBLIC_SELL_CAP_PROGRAM_LOCAL: process.env.NEXT_PUBLIC_SELL_CAP_PROGRAM_LOCAL,
  NEXT_PUBLIC_API_URL_DEVNET: process.env.NEXT_PUBLIC_API_URL_DEVNET,
  NEXT_PUBLIC_NATS_URL_DEVNET: process.env.NEXT_PUBLIC_NATS_URL_DEVNET,
  NEXT_PUBLIC_RPC_URL_DEVNET: process.env.NEXT_PUBLIC_RPC_URL_DEVNET,
  NEXT_PUBLIC_PROGRAM_ID_DEVNET: process.env.NEXT_PUBLIC_PROGRAM_ID_DEVNET,
  NEXT_PUBLIC_CP_SWAP_PROGRAM_ID_DEVNET: process.env.NEXT_PUBLIC_CP_SWAP_PROGRAM_ID_DEVNET,
  NEXT_PUBLIC_MARKETS_PROGRAM_ID_DEVNET: process.env.NEXT_PUBLIC_MARKETS_PROGRAM_ID_DEVNET,
  NEXT_PUBLIC_QUOTE_MINT_DEVNET: process.env.NEXT_PUBLIC_QUOTE_MINT_DEVNET,
  NEXT_PUBLIC_SELL_CAP_PROGRAM_DEVNET: process.env.NEXT_PUBLIC_SELL_CAP_PROGRAM_DEVNET,
  NEXT_PUBLIC_API_URL_MAINNET: process.env.NEXT_PUBLIC_API_URL_MAINNET,
  NEXT_PUBLIC_NATS_URL_MAINNET: process.env.NEXT_PUBLIC_NATS_URL_MAINNET,
  NEXT_PUBLIC_RPC_URL_MAINNET: process.env.NEXT_PUBLIC_RPC_URL_MAINNET,
  NEXT_PUBLIC_PROGRAM_ID_MAINNET: process.env.NEXT_PUBLIC_PROGRAM_ID_MAINNET,
  NEXT_PUBLIC_CP_SWAP_PROGRAM_ID_MAINNET: process.env.NEXT_PUBLIC_CP_SWAP_PROGRAM_ID_MAINNET,
  NEXT_PUBLIC_MARKETS_PROGRAM_ID_MAINNET: process.env.NEXT_PUBLIC_MARKETS_PROGRAM_ID_MAINNET,
  NEXT_PUBLIC_QUOTE_MINT_MAINNET: process.env.NEXT_PUBLIC_QUOTE_MINT_MAINNET,
  NEXT_PUBLIC_SELL_CAP_PROGRAM_MAINNET: process.env.NEXT_PUBLIC_SELL_CAP_PROGRAM_MAINNET,
  NEXT_PUBLIC_DEV_PROXY: process.env.NEXT_PUBLIC_DEV_PROXY,
};

// Optional public-host behavior belongs beside the shared network inputs,
// without pulling the public app's required authentication configuration in.
export const publicHostFlags: Readonly<Record<'devToolkitEnabled', boolean>> = {
  devToolkitEnabled: process.env.NEXT_PUBLIC_DEV_TOOLKIT === '1',
};
